export default __webpack_public_path__ + "static/media/stamp_mobile.5bc60fe9.png";